import React from "react";

import { Typography, Card, CardContent } from "@material-ui/core/";
import useStyles from "../../../assets/cardStyles";
import formatMoney from "../../../utils/formatMoney";

export default function Option(props) {
	const classes = useStyles();
	const { data } = props;

	const hasPrice = Boolean(data?.price);
	const price = hasPrice && <Typography variant="body2">precio: {formatMoney(data.price)}</Typography>;

	return (
		<Card className={classes.root3} raised>
			<CardContent style={{ textAlign: "left", padding: "0.25em 0 0 1em" }}>
				<Typography variant="h6">{data.name}</Typography>
				<Typography variant="body2">{data.description}</Typography>
				{price}
			</CardContent>
		</Card>
	);
}
